@if (displayTrigger) {
  <button
    [disabled]="!canSend"
    type="button"
    class="transparent-btn"
    (click)="openSendModal()"
  >
    <ng-content />
  </button>
}

<app-action-modal
  #actionModal
  [disabled]="submitted"
  [showHeader]="true"
  submitButtonClass="lty-btn-primary"
  size="md"
  headerIconState="success"
  (submitted)="sendAllProposals()"
>
  <div class="proposals-send-icon" headerIcon>
    <app-check-circle-outline-icon
      height="16px"
      width="16px"
      color="var(--success-500)"
    />
  </div>
  <ng-container mainTitle i18n
    >Êtes-vous certain de vouloir envoyer toutes les offres ?</ng-container
  >
  <label class="form-check d-flex align-items-center ps-0 gap-2 mt-2" subtitle>
    <input
      type="checkbox"
      class="form-check-input m-0"
      [(ngModel)]="withoutNotification"
    />
    <span class="form-check-label m-0" i18n>Sans notification</span>
  </label>
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
